"use client";

import React from "react";

import Chip from "@/components/global/ui/Chip";
import DecorationLine from "@/components/global/ui/DecorationLine";
import FAQList from "@/components/global/ui/FAQList";

import { cn } from "@/lib/utils";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { GROQImage } from "@/sanity/lib/definitions";
import { PortableTextBlock } from "sanity";
import GridNoise from "../global/ui/GridNoise";

export default function FAQSection({
  chip,
  text,
  items,
  className,
}: {
  chip?: {
    icon: GROQImage;
    text: string;
  };
  text?: PortableTextBlock[];
  items: {
    question: string;
    answer: PortableTextBlock[];
  }[];
  className?: string;
}) {
  return (
    <section
      className={cn(
        "overflow-clip bg-[#0A1A1D] relative w-full object-cover pb-[13rem] lg:pb-[22rem]",
        className,
      )}
    >
      <GridNoise />
      <div
        className="w-[min(187.5rem,100%)] mx-auto px-[2rem] lg:px-0
      flex flex-col items-center"
      >
        <div className=" flex flex-col items-center gap-[4rem]">
          {text && (
            <div
              className="richtext richtext-center prose-headings:text-[6rem] lg:prose-headings:text-[7rem] prose-headings:font-ivy prose-headings:text-white prose-headings:mb-[2rem]
              prose-p:text-white/60 prose-strong:font-light prose-strong:text-white prose-p:mb-[2rem] prose-p:text-[2.25rem]
              w-[90%] lg:w-[84.625rem]"
            >
              <PortableText value={text} components={richTextComponent} />
            </div>
          )}

          {items && (
            <FAQList
              className="w-[min(108.75rem,100%)] [&_img]:invert prose-h3:font-normal prose-h3:text-white prose-p:text-white/60 prose-p:font-light [&_.faq-item]:bg-[#112628]"
              faq={items}
            />
          )}
        </div>
      </div>
    </section>
  );
}
